import React from 'react'
import _ from 'lodash'


class Jibber extends React.Component{
    constructor(props){
        super(props)
        this.useState = this.useState.bind(this)
        this.setChanged = (value) => this.setState({changed: value})
    }

    useState(initState){
        // eslint-disable-next-line
        this.state= {changed: false, ...initState}
        _.each(initState, (value, key) => {
            this['set'+_.upperFirst(key)] = (value)=>this.setState({[key]: value, changed: true})
        })
    }
}
export default Jibber;

// Example use
/*
class Text extends Jibber{
    constructor(props){
        super(props)
        this.useState({
            'item': 1
        })
        // This will give us
        //this.setItem = (value)=> this.setState({'items': value})
    }

    render(){
        const props = this.props
        const {item} = this.state
        const {setItem} = this
        return (
            <Flex onClick={()=>setItem(2)}>
                {item}
            </Flex>
        )
    }
}

*/



// WEBPACK FOOTER //
// ./src/jibber.js